import React from 'react';
import { BRAND } from '../lib/content';
import { Button } from './ui/Button';
const LINKS = [{
  label: 'Beneficios',
  href: '#beneficios'
}, {
  label: 'Qué incluye',
  href: '#contenido'
}, {
  label: 'Proyectos',
  href: '#proyectos'
}, {
  label: 'Opiniones',
  href: '#opiniones'
}, {
  label: 'Preguntas',
  href: '#faq'
}];
export function Navbar() {
  return <header className="sticky top-0 z-40 w-full border-b border-navy-50 bg-white/90 backdrop-blur-md" data-id="element-283" data-mp="sd599n1jhh70">
      
    </header>;
}